<template>
    <div class="ld-container conversion-factor-container" style="height: 90vh; width: 100%">
        <div class="row" style="height: 100%">
            <div class="list-area col-md-6">
                <div>
                    <header-box :title="`${$t('환산계수 관리')}`" />
                </div>
                <div style="height: calc(100% - 80px); margin-top: 10px">
                    <!-- 테이블 영역 -->
                    <table-list
                        ref="table-list"
                        :title="'환산계수 목록'"
                        :columns="detailColumns"
                        :rows="detailItems"
                        :keyField="'conversionIdx'"
                        :useFilter="true"
                        :controls="controls"
                        :useMaxHeight="true"
                        :mode="'edit'"
                        :groupField="'fromUnit'"
                        :headerMargin="'0px'"
                        :fixedHeader="true"
                        @button-click="handleListButtonClick"
                        @row-click="handleDetailRowClick"
                    />
                </div>
            </div>
            <div class="detail-area col-md-6">
                <ConversionFactorDetail
                    ref="ConversionFactorDetail"
                    :title="'환산계수 상세'"
                    :selectedRow="selectedRow"
                    @data-updated="handleDetailUpdated"
                    @data-inserted="handleDetailInserted"
                    @closed="handleDetailClosed"
                />
            </div>
        </div>
    </div>
</template>

<script>
import HeaderBox from "@views/component/headerBox/management/Header.vue";
import TableList from "@views/component/v2.1/ListDetailView/TableList.vue";
import ConversionFactorDetail from "./components/ConversionFactorDetail.vue";
import backEndApi from "@src/api/backEndApi";
import * as popupMessages from "@src/consts/popupMessageConsts";
import { mapState } from "vuex";
import unitConversionService from "@libs/unitConversionService.js";

export default {
    components: {
        HeaderBox,
        TableList,
        ConversionFactorDetail,
    },
    props: {},

    data() {
        return {
            detailItems: [],
            controls: [
                { event: "delete", label: "삭제", class: "btn-danger" },
                { event: "refresh", label: "갱신", class: "bg-white text-black" },
                { event: "regist", label: "추가", class: "btn-primary" },
                { event: "apply", label: "적용", class: "btn-success" },
            ],
            detailColumns: [
                {
                    field: "fromUnit",
                    label: this.$t("원본 단위"),
                    tdClass: "text-center",
                    width: "100px",
                },
                {
                    field: "toUnit",
                    label: this.$t("목표 단위"),
                    tdClass: "text-center",
                    width: "100px",
                },
                // {
                //     field: "fromType",
                //     label: this.$t("원본 타입"),
                //     tdClass: "text-center",
                //     width: "100px",
                //     formatter: (value) => {
                //         if (!value) return "-";
                //         const code = this.energySourceCodes?.find((code) => code.value === value);
                //         return code ? code.text : value;
                //     },
                // },
                // {
                //     field: "toType",
                //     label: this.$t("목표 타입"),
                //     tdClass: "text-center",
                //     width: "100px",
                //     formatter: (value) => {
                //         if (!value) return "-";
                //         const code = this.energySourceCodes?.find((code) => code.value === value);
                //         return code ? code.text : value;
                //     },
                // },
                {
                    field: "conversionFactor",
                    label: this.$t("환산 계수"),
                    tdClass: "text-right",
                    width: "120px",
                },
                {
                    field: "effectivePeriod",
                    label: this.$t("적용 기간"),
                    tdClass: "text-center",
                    width: "200px",
                },
            ],
            popupMessages,
            selectedRow: null,
        };
    },
    computed: {
        ...mapState({
            unitCodes: (state) => state.unitCodes,
            energySourceCodes: (state) => state.commonCodes.energySourceCode,
        }),
    },
    created() {},
    async mounted() {
        await this.loadAllDetails();
    },
    methods: {
        getEnergySourceCodes(value) {
            return this.energySourceCodes.find((code) => code.value === value)?.text || "-";
        },
        async handleListButtonClick(event, options) {
            switch (event) {
                case "regist":
                    await this.registNew();
                    break;

                case "delete":
                    await this.deleteChecked();
                    break;

                case "refresh":
                    await this.loadAllDetails(event);
                    break;

                case "apply":
                    await this.applyConversions();
                    break;

                default:
                    console.warn("Unhandled Component Event. event:", event, "options:", options);
                    break;
            }
        },

        async loadAllDetails(event) {
            try {
                const result = await backEndApi.unitConversion.getConversionList({});
                if (result.status === 200) {
                    // 적용기간 필드 추가
                    const items = (result.data || []).map((item) => {
                        const from = item.effectiveFrom;
                        const to = item.effectiveTo;

                        let periodText = "";
                        if (!from && !to) {
                            periodText = "전체 기간";
                        } else {
                            const fromText = from || "무기한";
                            const toText = to || "무제한";
                            periodText = `${fromText} ~ ${toText}`;
                        }

                        return {
                            ...item,
                            effectivePeriod: periodText,
                        };
                    });
                    this.detailItems = items;
                    if (event) await this.alertNoti(popupMessages.COMMON_REFRESH_POPUP_MESSAGE);
                } else {
                    this.alertWarning(`${result.data.message}`);
                }
                return result;
            } catch (e) {
                console.error(e);
                this.alertDanger("데이터 조회 중 오류가 발생했습니다.", "", e.message || "");
            }
        },

        async deleteChecked() {
            try {
                const confirm = await this.alertConfirmWarning(popupMessages.COMMON_DELETE_CONFIRM_POPUP_MESSAGE);
                if (!confirm.value) return;

                const checked = this.$refs["table-list"].getCheckedRows();
                if (!this.isEmpty(checked)) {
                    for (const item of checked) {
                        let result = await backEndApi.unitConversion.deleteConversion(item.conversionIdx);
                        if (result.status != 200) {
                            this.alertWarning(`${result.data.message}`);
                            return;
                        }
                    }
                    await this.alertNoti(popupMessages.COMMON_DELETE_POPUP_MESSAGE);
                    await this.loadAllDetails();
                    await this.$refs["ConversionFactorDetail"].clearData();
                } else {
                    this.alertNoti(popupMessages.COMMON_DELETE_NOTI_POPUP_MESSAGE);
                }
            } catch (e) {
                console.error(e);
                this.alertDanger("삭제 중 오류가 발생했습니다.", "", e.message || "");
            }
        },

        async applyConversions() {
            try {
                const confirm = await this.alertConfirmWarning(
                    "환산계수를 적용하시겠습니까?\n\n" +
                        "적용하면 시스템 전체에 변경사항이 반영됩니다.\n" +
                        "계속하시겠습니까?"
                );
                if (!confirm.value) return;

                const result = await backEndApi.unitConversion.applyConversions();
                if (result.status === 200) {
                    await this.alertNoti("환산계수 적용 완료", "", `버전: ${result.data.version || "알 수 없음"}`);

                    // 적용 후 최신 환산계수 동기화
                    try {
                        console.log("[ConversionFactor] 환산계수 적용 후 동기화 시작");
                        await unitConversionService.manualSync();
                        console.log("[ConversionFactor] 환산계수 동기화 완료");
                    } catch (syncError) {
                        console.error("[ConversionFactor] 환산계수 동기화 실패:", syncError);
                        // 동기화 실패해도 적용은 성공했으므로 경고만 표시
                        this.alertWarning(
                            "환산계수는 적용되었지만, 최신 데이터 동기화에 실패했습니다. 페이지를 새로고침해주세요."
                        );
                    }
                } else {
                    this.alertWarning(`${result.data.message}`);
                }
            } catch (e) {
                console.error(e);
                this.alertDanger("적용 중 오류가 발생했습니다.", "", e.message || "");
            }
        },

        async registNew() {
            this.$refs["ConversionFactorDetail"].newData();
        },

        handleDetailRowClick(row) {
            const payload = row && row.conversionIdx ? row : row && row.row ? row.row : row;
            // 편집/신규 모드일 경우 닫기 확인 후 이동
            const proceed = this.$refs["ConversionFactorDetail"]?.notifyCancelEdit
                ? this.$refs["ConversionFactorDetail"].notifyCancelEdit()
                : Promise.resolve(true);
            Promise.resolve(proceed).then((ok) => {
                if (!ok) return;
                // 강제로 보기 모드로 전환
                if (this.$refs["ConversionFactorDetail"]) this.$refs["ConversionFactorDetail"].isEditMode = false;
                if (payload && payload.conversionIdx) {
                    // selectedRow를 설정하면 watch가 자동으로 loadData()를 호출함
                    this.selectedRow = {
                        ...payload,
                    };
                }
            });
        },

        // Event Handling
        async handleDetailUpdated() {
            await this.loadAllDetails();
            // 상세 정보도 다시 로드하여 최신 데이터 반영
            if (this.selectedRow?.conversionIdx) {
                // selectedRow를 새 객체로 설정하여 watch 트리거
                this.selectedRow = {
                    ...this.selectedRow,
                };
            }
        },

        async handleDetailInserted(data) {
            await this.loadAllDetails();
            // 새로 추가된 항목 선택
            if (data && data.conversionIdx) {
                // selectedRow를 설정하면 watch가 자동으로 loadData()를 호출함
                this.selectedRow = { ...data };
            }
        },

        handleDetailClosed() {
            this.selectedRow = null;
        },
    },
};
</script>

<style scoped>
.ld-container {
    height: 90vh;
    width: 100%;
    background-color: white;
    border-radius: 10px;
    overflow: hidden;
    padding: 10px 30px 10px 20px;
}

.ld-container .list-area {
    height: 100%;
    overflow: hidden;
    padding: 10px;
}

.ld-container .detail-area {
    height: 100%;
    margin-right: 0px;
    padding: 0px 10px 0px 10px;
    border-top: 1px solid #f4f4f4;
    border-right: 2px solid #e7e7e7;
    border-bottom: 2px solid #e7e7e7;
    border-left: 1px solid #f4f4f4;
    background-color: #f9f9f9;
    border-radius: 10px;
}

.search-area {
    margin-bottom: 10px;
    padding: 10px;
    background-color: #f8f9fa;
    border-radius: 5px;
}
</style>
